<template>
	<div class="clans">
		<van-nav-bar fixed @click-left="onClickLeft">
			<template #left v-if="code=='tree'||code=='search'">
				<img src="../../assets/img/icon/left-arrow.png" class="icon" />
			</template>
			<template #title>
				<van-search
				  v-model.trim="searchText" 
				  shape="round"
				  :class="{skin_bgcolor:true}"
				  show-action
				  :placeholder="placeholder[code]"
				  @search="onSearch"
				  v-if="code!='search'"
				>
					<template #left-icon>
						<img round class="logo" src="../../assets/logo.png" />
					</template>
					<template #action>
						<van-icon name="search" size="22px" color="#fff" @click="onSearch" v-if="code=='list'"/>
						<van-popover v-if="code=='tree'" v-model="showMoreSearchAction" trigger="click" :offset="[14,0]" placement="bottom-end" @select="clickMoreSearchAction" :actions="searchActions">
						  <template #reference>
							  <van-icon name="search" size="20px" color="#fff"/>
						  </template>
						</van-popover>
					</template>
				</van-search>
				<div v-else>{{title}}</div>
			</template>
			<template #right>
				<van-icon name="add-o" size="20px" color="#fff" @click="onAdd" v-if="code=='list'"/>
				<van-icon name="share" size="20px" color="#fff" @click="showShareSheet=!showShareSheet" v-if="code=='list'" style="margin-left:5px;"/>
				<van-popover v-if="code=='tree'&&infoAuth" v-model="showMoreAction" trigger="click" :offset="[14,0]" placement="bottom-end" @select="clickMoreAction" :actions="actions">
				  <template #reference>
					  <van-icon name="apps-o" size="20px" color="#fff"/>
				  </template>
				</van-popover>
			</template>
		</van-nav-bar>

		<router-view :keyword="searchText" ref="clans_router"/>
		

		<share ref="ref-wx-share" :showShareSheet.sync="showShareSheet" :shareUrl="shareQRCodeUrl" :shareConfig="shareConfig" :botm="50" v-show="showShareSheet" v-if="initShareSheet"/>
	</div>
</template>

<script type="text/ecmascript-6">
import "@/assets/css/clans.less";
let pinyin = require('js-pinyin');
import {chkWeiXin } from "@/utils/common.js";
import {Search,Popover} from "vant";
import Share from "@/components/Commom/Share";

export default {
	name: "clans",
	components: {
		"van-search":Search,
		"van-popover":Popover,
		"share":Share
	},
	data() {
		return {
			title: "",
			code:"list",
			placeholder:{'list':'族姓、谱名、堂号','tree':'名字、曾用名、字号'},
			infoAuth:false,
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			searchText: '',
			routerTo:'',
			actions: [
				{ text: '资料编辑', icon: 'edit',code:'info' },
				{ text: '宗源管理', icon: 'fire-o',code:'source' },
				{ text: '密码设置', icon: 'setting-o',code:'set' },
				{ text: '删除族谱', icon: 'delete',code:'delete' }
			],
			showMoreAction:false,
			searchActions: [
				{ text: '默认查询', icon: 'search',code:'all' },
				{ text: '族谱查询', icon: 'search',code:'clans' },
				{ text: '更多查询', icon: 'search',code:'more' }
			],
			showMoreSearchAction:false,
			scsx:{
				'ZI':{'sc':'子时','sx':'鼠','sj':'23:00','order':0},
				'CHOU':{'sc':'丑时','sx':'牛','sj':'01:00','order':1},
				'YIN':{'sc':'寅时','sx':'虎','sj':'03:00','order':2},
				'MAO':{'sc':'卯时','sx':'兔','sj':'05:00','order':3},
				'CHEN':{'sc':'辰时','sx':'龙','sj':'07:00','order':4},
				'SI':{'sc':'巳时','sx':'蛇','sj':'09:00','order':5},
				'WU':{'sc':'午时','sx':'马','sj':'11:00','order':6},
				'WEI':{'sc':'未时','sx':'羊','sj':'13:00','order':7},
				'SHEN':{'sc':'申时','sx':'猴','sj':'15:00','order':8},
				'YOU':{'sc':'酉时','sx':'鸡','sj':'17:00','order':9},
				'XU':{'sc':'戌时','sx':'狗','sj':'19:00','order':10},
				'HAI':{'sc':'亥时','sx':'猪','sj':'21:00','order':11}
			},
			familyNameIndex:[],

			newsNav:this.Conf.newsNav,
			tabact:0,
			items: [],
			
			showShareSheet:false,
			shareQRCodeUrl:'',
			shareConfig:{},
			initShareSheet:false
		};
	},
	mounted() {
		// 获取浏览器可视区域高度
		this.winH = `${document.documentElement.clientHeight}`;
		window.onresize = function temp() {
			this.winH = `${document.documentElement.clientHeight}`;
		};
		
	},
	created() {
		let families = [];
		let pinyins = [];
		let fnames = [
				"赵","钱","孙","李","周","吴","郑","王","冯","陈","褚","卫","蒋","沈","韩","杨","朱","秦","尤",
				"许","何","吕","施","张","孔","曹","严","华","金","魏","陶","姜","戚","谢","邹","喻","柏","水",
				"窦","章","云","苏","潘","葛","奚","范","彭","郎","鲁","韦","昌","马","苗","凤","花","方","俞",
				"任","袁","柳","酆","鲍","史","唐","费","廉","岑","薛","雷","贺","倪","汤","滕","殷","罗","毕",
				"郝","邬","安","常","乐","于","时","傅","皮","卞","齐","康","伍","余","元","卜","顾","孟","平",
				"黄","和","穆","萧","尹","姚","邵","湛","汪","祁","毛","禹","狄","米","贝","明","臧","计","伏",
				"成","戴","谈","宋","茅","庞","熊","纪","舒","屈","项","祝","董","粱","杜","阮","蓝","闵","席",
				"季","麻","强","贾","路","娄","危","江","童","颜","郭","梅","盛","林","刁","钟","徐","邱","骆",
				"高","夏","蔡","田","樊","胡","凌","霍","虞","万","支","柯","昝","管","卢","莫","经","房","裘",
				"缪","干","解","应","宗","丁","宣","贲","邓","郁","单","杭","洪","包","诸","左","石","崔","吉",
				"钮","龚","程","嵇","邢","滑","裴","陆","荣","翁","荀","羊","於","惠","甄","麴","家","封","芮",
				"羿","储","靳","汲","邴","糜","松","井","段","富","巫","乌","焦","巴","弓","牧","隗","山","谷",
				"车","侯","宓","蓬","全","郗","班","仰","秋","仲","伊","宫","宁","仇","栾","暴","甘","钭","厉",
				"戎","祖","武","符","刘","景","詹","束","龙","叶","幸","司","韶","郜","黎","蓟","薄","印","宿",
				"白","怀","蒲","邰","从","鄂","索","咸","籍","赖","卓","蔺","屠","蒙","池","乔","阴","欎","胥",
				"能","苍","双","闻","莘","党","翟","谭","贡","劳","逄","姬","申","扶","堵","冉","宰","郦","雍",
				"舄","璩","桑","桂","濮","牛","寿","通","边","扈","燕","冀","郏","浦","尚","农","温","别","庄",
				"晏","柴","瞿","阎","充","慕","连","茹","习","宦","艾","鱼","容","向","古","易","慎","戈","廖",
				"庾","终","暨","居","衡","步","都","耿","满","弘","匡","国","文","寇","广","禄","阙","东","殴",
				"殳","沃","利","蔚","越","夔","隆","师","巩","厍","聂","晁","勾","敖","融","冷","訾","辛","阚",
				"那","简","饶","空","曾","毋","沙","乜","养","鞠","须","丰","巢","关","蒯","相","查","後","荆",
				"红","游","竺","权","逯","盖","益","桓","公","万俟","司马","上官","欧阳","夏侯","诸葛","闻人",
				"东方","赫连","皇甫","尉迟","公羊","澹台","公冶","宗政","濮阳","淳于","单于","太叔","申屠","公孙",
				"仲孙","轩辕","令狐","钟离","宇文","长孙","慕容","鲜于","闾丘","司徒","司空","亓官","司寇","仉",
				"督","子车","颛孙","端木","巫马","公西","漆雕","乐正","壤驷","公良","拓跋","夹谷","宰父","谷梁",
				"晋","楚","闫","法","汝","鄢","涂","钦","段干","百里","东郭","南门","呼延","归","海","羊舌","微生",
				"岳","帅","缑","亢","况","后","有","琴","梁丘","左丘","东门","西门","商","牟","佘","佴","伯","赏",
				"南宫","墨","哈","谯","笪","年","爱","阳","佟","第五","言","福","百","家","姓","终"
			];

		let chkUniqueFamily = function(name, datas){
			let rst = false;
			for(var i=0,il=datas.length;i<il;i++){
				if(datas[i] == name){
					rst = true;
					break;
				}
			}
			return rst;
		}
		let others = [];
		for(var i=0,il=fnames.length;i<il;i++){
			let pys = pinyin.getFullChars(fnames[i]);
			if(pys == ""){
				if(!chkUniqueFamily(fnames[i], others)){
					others.push(fnames[i]);
				}
				continue;
			}
			pys = (pys!=''&&pys)?pys:"#";
			if(!families[pys]){
				families[pys] = [];
				pinyins.push(pys);
			}
			families[pys].push(fnames[i]);
		}

		pinyins.sort();
		let familyInd = [];
		let fchar = "";
		for(var i=0,il=pinyins.length; i<il; i++){
			if(fchar=="" || fchar!= pinyins[i].substring(0, 1)){
				fchar = pinyins[i].substring(0, 1);
				familyInd.push({'char':fchar,'data':[]});
			}
			var fms = families[pinyins[i]];
			fms.sort();
			for(var i1=0,il1=fms.length; i1<il1; i1++){
				if(!chkUniqueFamily(fms[i1], familyInd[familyInd.length-1]['data'])){
					familyInd[familyInd.length-1]['data'].push(fms[i1]);
				}
			}
		}
		familyInd.push({'char':'#','data':others});
		this.familyNameIndex = familyInd;

		let isWxEnv = chkWeiXin();
		this.shareQRCodeUrl = isWxEnv?location.href:(this.Conf.clientOrigin+'/m/#/Clans');
		
		this.shareConfig = {
			title:'【'+top._SHARE_INFO.title+'】'+'国有史，方有志，家有谱',
			desc:'寻宗溯源，章谱奕世。云端记录氏族源流、迁徙、繁衍与发展，延续宗族记忆。',
			link:this.shareQRCodeUrl,
			imgUrl:this.Conf.clientOrigin+'/upload/cover_normal.jpg'
		};
		this.initShareSheet = true;
	},
	methods: {
		// 返回
		onClickLeft() {
			if(this.$refs['clans_router'].onClickLeft){
				this.$refs['clans_router'].onClickLeft();
				return false;
			}
			this.$router.push({path:'/Clans'});
		},
		chkLogined(){
			if(!(this.u_id && this.token)){
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "登录后可以查看更多",
					showCancelButton:true,
					confirmButtonText:'马上登录',
					cancelButtonText:'再看看'
				})
				.then(() => {
					this.$router.push({ path: "/Login" });
					return false;
				})
				.catch(error => {
					return false;
				});
				return false;
			}
			return true;
		},
		onSearch(){
			if(this.chkLogined()){
				this.$refs['clans_router'].searchData()
			}
		},
		onAdd(){
			if(this.chkLogined()){
				this.$refs['clans_router'].onAdd();
			}
		},
		goPedigree(pid){
			this.routerTo = '/Clans/Chart/'+pid;
			this.$router.push(this.routerTo)
		},
		clickMoreAction(act,ind){
			if(act.code=="info"){
				this.$refs['clans_router'].onEdit();
			}
			if(act.code=="set"){
				this.$refs['clans_router'].onResetPwd();
			}
			if(act.code=="source"){
				this.$refs['clans_router'].showPedigreeSource();
			}
			if(act.code=="delete"){
				this.$dialog
				.confirm({
					title: "温馨提醒",
					message: "删除后数据将不可恢复，确定？",
				})
				.then(() => {
					this.$refs['clans_router'].deletePedigree();
				})
				.catch((error) => {});
			}
		},
		clickMoreSearchAction(act,ind){
			if(this.chkLogined()){
				this.$refs['clans_router'].searchData(act.code);
			}
		}
	},
	computed:{
	},
	filters:{
	},
	watch: {
		$route(to, from) {
			this.$refs['ref-wx-share'].resetInit();
		}
	}
};
</script>




// WEBPACK FOOTER //
// src/components/Clans/Main.vue